export const TRY_FETCH_PAGES = 'tryFetchPages';
export const SET_PAGES = 'setPages';
export const SET_SELECTED_PAGE = 'setSelectedPage';
